import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import Constants from "../../Constants";
import Swiper, {Autoplay, EffectFade, Navigation} from "swiper";

import 'swiper/css';
import 'swiper/css/effect-fade';

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data() {
        return {
            deviceWidth: {
                type: Number,
                default: 0
            }
        };
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
        this.deviceWidth = window.innerWidth;
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function() {
            self.$nextTick(function() {
                // banner initialize
                // banner
                const banner_swiper = new Swiper(".banner_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".banner-button-next",
                        prevEl: ".banner-button-prev",
                    },
                    on: {
                        slideChange:function(swiper){
                            $('.banner_swiper .scroll-txt h3').hide();
                            $('.banner_swiper .scroll-txt h3').eq(swiper.realIndex).show()
                        }
                    }
                });
                
                // if(_.get(this, 'contentData.charityNews', []).length > 3){
                    const news_swiper = new Swiper(".news-swiper", {
                        // configure Swiper to use modules
                        modules: [Navigation],
                        // Optional parameters
                        loop: true,
                        //autoplay:true,
                        // Navigation arrows
                        navigation: {
                            nextEl: ".news-swiper-button-next",
                            prevEl: ".news-swiper-button-prev",
                        },
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                        breakpoints: {
                            // when window width is >= 100px
                            100: {
                                slidesPerGroup: 1,
                                slidesPerView: 1
                            },
                            // when window width is >= 780px
                            780: {
                                slidesPerGroup: 3,
                                slidesPerView: 3
                            }
                        }
                    });
                // }

                self.newsSwiperButton()
                $(window).resize(function (){
                    self.newsSwiperButton()
                })
            });
        });
        
    },
    methods: {   
        
        newsSwiperButton(){
            let isMobile = !!window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

            let newsLength = _.get(this, 'contentData.charityNews', []).length
            if(newsLength > 3 || isMobile) {

            }else{
                $('.news-swiper-button-next').hide()
                $('.news-swiper-button-prev').hide()
            }

        }
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        bannersData() {
            return _.get(this, 'contentData.bannerList', []) || [];
        },
        charityIntroduces() {
            return _.get(this, 'contentData.charityIntroduces', []) || [];
        },
        charityNews() {
            return _.get(this, 'contentData.charityNews', []) || [];
        },
    }, // end of computed
}).$mount('#app');